import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { retryLazy as lazy } from './RetryLazy';
import withSuspense from './Suspense';

const SetPassword = lazy(() => import('../../pages/auth-pages/SetPassword'));
const PrivacyPolicyPage = lazy(() => import('../../pages/PrivacyPolicyPage'));
const Protected = lazy(() => import('./Protected'));

const Portal: React.FC = () => {
  return (
    <Routes>
      <Route path="/setpassword" element={withSuspense(SetPassword)} />
      <Route path="/privacypolicy" element={withSuspense(PrivacyPolicyPage)} />
      <Route path="*" element={withSuspense(Protected)} />
    </Routes>
  );
};

export default Portal;
